<template>
    <div class="manhua-page">
        <!-- Hero -->
        <section class="hero">
            <div class="hero__bg">
                <!-- <img src="../../assets/image/manhua_6.png" alt=""> -->
            </div>
            <div class="hero__content">
                <h1 class="hero__title">发现你的下一部好漫画</h1>
                <p class="hero__subtitle">精选国漫·热血·恋爱·奇幻 · 每天更新</p>
                <!-- <div class="hero__search">
                    <input class="input" type="text" placeholder="搜索漫画、作者、标签… (示意)" />
                    <button class="btn btn--primary" type="button">搜索</button>
                </div> -->
            <!-- <div class="hero__tags">
                    <span class="tag"># 热门</span>
                    <span class="tag"># 新番</span>
                    <span class="tag"># 完结</span>
                    <span class="tag"># 冒险</span>
                    <span class="tag"># 校园</span>
                </div> -->
            </div>
        </section>

        <!-- 分类导航（静态示意） -->
        <section class="categories">
            <div class="container">
                <ul class="pill-nav">
                    <li :class="['pill',{ 'pill--active':Lm==index}]" v-for="(item,index) in lanmuList" :key="index" @click="LanmuClick(index)">{{item}}</li>
                </ul>
            </div>
        </section>

        <!-- 漫画卡片网格（仅布局与样式） -->
        <section class="cards">
            <div class="container grid">
                <div class="card" v-for="(item,index) in Mb" :key="index" @click="TooTiao(item)">
                    <div class="card__cover">
                        <img :src="item.image" alt="">
                    </div>
                    <div class="card__info">
                        <h3 class="card__title">{{item.name}}</h3>
                        <p class="card__meta">{{item.sort_name_text}}</p>
                        <p class="card__meta">{{item.content}}</p>
                    </div>
                </div>
            </div>
        </section>
    </div>

</template>

<script>
import axios from 'axios';
export default {
    name: 'ManhuaHome',
    data() {
        return {
            lanmuList:['全部','连载','剧情','爱情','冒险','动作','搞笑','恐怖','校园'],
            Lm:0,
            Mb:[],//漫画展示数组
        }
    },
    mounted() {
        let data ={
            fenleiid:this.Lm+1
        }
        axios.post('/api/index/getfenlei',data)
        .then(res=>{
            console.log(res.data.data[0].data)
            this.Mb = res.data.data[0].data;
        }).catch(err=>{
            console.log(err)

        })
    },
    methods:{
        LanmuClick(index){
            this.Lm=index;
            let data ={
                fenleiid:index+1
            }
            axios.post('/api/index/getfenlei',data)
            .then(res=>{
                console.log(res.data.data[0].data)
                this.Mb = res.data.data[0].data;
            }).catch(err=>{
                console.log(err)

            })
        },
        //跳转
        TooTiao(t){
            console.log(t)
            this.$router.push({
                name:'Nxiangqing',
                params:{
                    name:t.name
                }
            })
        }
    }
}
</script>

<style scoped>
.manhua-page {
    color: #0f172a;
    background: #f8fafc;
    min-height: 100vh;
}

/* Hero */
.hero {
    position: relative;
    padding: 225px 16px 64px;
    overflow: hidden;
}

.hero__bg {
    position: absolute;
    inset: 0;
    background-image: url('../../assets/image/manhua_6.png');
    background-size: 100% auto;
    filter: brightness(0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1;
    img{
        width: 1400px;
        height: 100%;
        object-fit: cover;
    }
}

.hero__content {
    position: relative;
    z-index: 1;
    max-width: 1100px;
    margin: 0 auto;
    text-align: center;
    color: #334155;
}

.hero__title {
    font-size: 40px;
    line-height: 1.15;
    margin: 0 0 12px;
    letter-spacing: 0.5px;
    color: #ffffff;
    text-shadow: 0 8px 28px rgba(15, 23, 42, .08);
}

.hero__subtitle {
    opacity: .9;
    margin-bottom: 24px;
    color: #ffffff;
}

.hero__search {
    display: flex;
    gap: 12px;
    justify-content: center;
    align-items: center;
    margin: 16px auto 10px;
    max-width: 680px;
}

.input {
    flex: 1;
    min-width: 0;
    height: 44px;
    padding: 0 14px;
    border-radius: 12px;
    border: 1px solid rgba(15, 23, 42, .12);
    background: #ffffff;
    color: #0f172a;
    outline: none;
    backdrop-filter: blur(2px);
    transition: border .2s, box-shadow .2s, background .2s;
}

.input:focus {
    border-color: #60a5fa;
    box-shadow: 0 0 0 4px rgba(96, 165, 250, .2);
    background: #ffffff;
}

.btn {
    height: 44px;
    padding: 0 18px;
    border-radius: 12px;
    border: none;
    cursor: pointer;
    font-weight: 600;
    letter-spacing: .3px;
    transition: transform .15s ease, box-shadow .15s ease, background .2s;
}

.btn--primary {
    color: #0b1020;
    background: linear-gradient(135deg, #d6f8f4, #e7cbfe);
}

.btn--primary:hover {
    transform: translateY(-1px);
}

.btn--ghost {
    color: #0f172a;
    background: rgba(148, 163, 184, .12);
    border: 1px solid rgba(148, 163, 184, .3);
}

.btn--ghost:hover {
    background: rgba(148, 163, 184, .2);
}

.hero__tags {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin-top: 14px;
    flex-wrap: wrap;
}

.tag {
    color: #2563eb;
    background: rgba(37, 99, 235, .08);
    border: 1px solid rgba(37, 99, 235, .22);
    padding: 6px 10px;
    border-radius: 999px;
    font-size: 12px;
    backdrop-filter: blur(2px);
}

/* 分类导航 */
.categories {
    padding: 10px 16px 0;
}

.container {
    max-width: 1300px;
    margin: 0 auto;
}

.pill-nav {
    list-style: none;
    margin: 0;
    padding: 12px;
    display: flex;
    gap: 10px;
    overflow: auto;
    scrollbar-width: thin;
}

.pill {
    white-space: nowrap;
    color: #0f172a;
    background: rgba(226, 232, 240, .6);
    border: 1px solid rgba(148, 163, 184, .5);
    padding: 8px 14px;
    border-radius: 999px;
    transition: background .2s, transform .15s;
    cursor: default;
}

.pill:hover {
    transform: translateY(-2px);
    cursor: pointer;
}

.pill--active {
    color: #ffffff;
    background: linear-gradient(135deg, #007c90, #0087e0);
    border-color: transparent;
}

/* 卡片网格 */
.cards {
    padding: 24px 16px 8px;
}

.grid {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 18px;
}

@media (max-width: 1100px) {
    .grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 768px) {
    .grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 480px) {
    .grid {
        grid-template-columns: 1fr;
    }
}

.card {
    position: relative;
    display: block;
    border-radius: 16px;
    overflow: hidden;
    background: #ffffff;
    border: 1px solid rgba(15, 23, 42, .08);
    text-decoration: none;
    transform: translateZ(0);
    transition: transform .2s ease, box-shadow .2s ease, border-color .2s;
    cursor: pointer;
}

.card:hover {
    transform: translateY(-6px);
    box-shadow: 0 20px 40px rgba(2, 8, 23, .12);
    border-color: rgba(15, 23, 42, .18);
}

.card::after {
    content: "";
    position: absolute;
    inset: 0;
    background: radial-gradient(600px 120px at var(--mx, 50%) -10%, rgba(255, 255, 255, .14), transparent 40%);
    transition: opacity .2s;
    opacity: 0;
    pointer-events: none;
}

.card:hover::after {
    opacity: 1;
}

.card__cover {
    width: 245px;
    height:300px;
    background-size: cover;
    background-position: center;
    filter: saturate(1.05) contrast(1.02);
    overflow: hidden;
   
}
.card__cover>img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.card__info {
    padding: 12px 12px 14px;
    color: #334155;
}

.card__title {
    margin: 0 0 6px;
    font-size: 16px;
    color: #0f172a;
}

.card__meta {
    margin: 0;
    opacity: .8;
    font-size: 13px;
    color: #64748b;
    margin-bottom: 5px;
     word-break: break-all;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1; /* 超出几行省略 */
              overflow: hidden;
}

/* Promo */
.promo {
    padding: 8px 16px 28px;
}

.promo__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

@media (max-width: 900px) {
    .promo__grid {
        grid-template-columns: 1fr;
    }
}

.promo__item {
    border-radius: 18px;
    padding: 22px;
    background: linear-gradient(135deg, rgba(56, 189, 248, .18), rgba(34, 197, 94, .16));
    border: 1px solid rgba(15, 23, 42, .08);
    color: #334155;
    box-shadow: inset 0 1px rgba(255, 255, 255, .6);
}

.promo__item h3 {
    margin: 0 0 6px;
    color: #0f172a;
}

.promo__item p {
    margin: 0 0 14px;
    opacity: .9;
}

/* 加载更多 */
.loadmore {
    padding: 12px 16px 60px;
    display: flex;
    justify-content: center;
}

/* 微交互：光标跟随高光 */
.card {
    --mx: 50%;
}

.card:hover {
    --mx: var(--mx);
}

.card {
    position: relative;
}

.card:where(:hover, :focus-visible) {
    outline: none;
}

.card {
    will-change: transform;
}

/* 小浮动动画用于标签与按钮 */
@keyframes floaty {
    from {
        transform: translateY(0px);
    }

    50% {
        transform: translateY(-2px);
    }

    to {
        transform: translateY(0px);
    }
}

.tag:nth-child(2n) {
    animation: floaty 4s ease-in-out infinite;
}

.tag:nth-child(2n+1) {
    animation: floaty 5s ease-in-out infinite;
}
</style>
